(() => {
  window.park = Object.assign({}, window.park, {
    consent: {
      isGroupActive: (key) => {
        let splitedGroups = [];
        const activeGroups = window.park.cookie.get('OptanonConsent').split('&');
        if (activeGroups.length > 0) {
          // eslint-disable-next-line
          for (const cookieEntry in activeGroups) {
            if (activeGroups[cookieEntry].indexOf('groups') > -1) {
              activeGroups[cookieEntry] = activeGroups[cookieEntry].replace('groups=', '');
              activeGroups[cookieEntry] = activeGroups[cookieEntry].replace(/%2C/g, '');
              splitedGroups = activeGroups[cookieEntry].split('%3A1');
            }
          }
        }
        return splitedGroups.includes(key);
      },
      tcStringParse: (tcString) => {
        console.log(window.TCString.decode(tcString));
      },
    },
  });
})();
